// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.middle-content .alerts-container {
  background: #202437;
  padding: 20px 0px 20px 20px;
  margin-top: 16px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}
.middle-content .alerts-container .custom-carousel {
  height: 170px;
  position: relative;
}
.middle-content .alerts-container .custom-carousel .react-multi-carousel-list {
  height: 170px;
  overflow: unset !important;
}
.middle-content .alerts-container .custom-carousel .react-multi-carousel-track {
  position: absolute !important;
  left: 0;
  top: 0;
  height: 170px;
}
.middle-content .alerts-container .alert-top-panel {
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
}
.middle-content .alerts-container .alert-top-panel .d-flex {
  display: flex;
  align-items: center;
  gap: 10px;
}
.middle-content .alerts-container .alert-top-panel .alert-icon {
  border-radius: 10px;
  border: 1px solid #3B435E;
  padding: 7px;
  display: flex;
}
.middle-content .alerts-container .alert-title {
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 91.523%;
  display: flex;
  align-items: center;
  gap: 4px;
}
.middle-content .alerts-container .alert-title span {
  color: rgba(255, 255, 255, 0.6980392157);
  font-weight: 300;
  display: flex;
  align-items: center;
}
.middle-content .alerts-container .alert-title .alert-count {
  width: 20px;
  display: flex;
  justify-content: center;
}
.middle-content .alerts-container .alert-wrapper.selected {
  background: #28304C;
}
.middle-content .alerts-container .alert-wrapper {
  width: 86.872%;
  height: 136px;
  padding: 17px 16px;
  border-radius: 10px;
  background: #2B3045;
  cursor: pointer;
}
.middle-content .alerts-container .alert-wrapper:hover {
  background: #28304C;
}
.middle-content .alerts-container .alert-wrapper span {
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.7);
  display: block;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items {
  display: flex;
  justify-content: space-between;
  margin-bottom: 19px;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .left .carousel-title {
  color: #FFF;
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  width: 232px;
  display: block;
  margin-bottom: 10px;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right {
  border-radius: 3px;
  background: rgba(255, 66, 89, 0.1);
  padding: 0px 6px;
  display: flex;
  align-items: center;
  gap: 3px;
  height: 22px;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right span {
  color: #FF4259;
  font-family: "Manrope";
  font-size: 12px;
  font-weight: 500;
  display: block;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right .circle-icon {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #FF4259;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right.medium {
  background: rgba(255, 139, 30, 0.1);
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right.medium span {
  color: #FF8B1E;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right.medium .circle-icon {
  background: #FF8B1E;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right.low {
  background: rgba(88, 218, 120, 0.1);
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right.low span {
  color: #58DA78;
}
.middle-content .alerts-container .alert-wrapper .alert-top-items .right.low .circle-icon {
  background: #58DA78;
}
.middle-content .alerts-container .alert-wrapper .alert-bottom-items .d-flex {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.middle-content .alerts-container .alert-wrapper .alert-bottom-items .image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.middle-content .alerts-container .react-multi-carousel-list .react-multiple-carousel__arrow {
  background: transparent !important;
  position: absolute;
  top: -50px;
  left: unset !important;
  right: 23px !important;
  min-width: 24px;
  min-height: 24px;
}
.middle-content .alerts-container .react-multi-carousel-list .react-multiple-carousel__arrow--left {
  left: unset !important;
  right: 49px !important;
}
.middle-content .alerts-container .react-multi-carousel-list .react-multiple-carousel__arrow--left::before {
  font-size: 16px !important;
  font-weight: 600;
}
.middle-content .alerts-container .react-multi-carousel-list .react-multiple-carousel__arrow--left::after {
  content: "\\e825";
  font-size: 16px;
  color: rgba(255, 255, 255, 0.2);
  font-family: "revicons";
  text-align: center;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 26px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-weight: 600;
}
.middle-content .alerts-container .react-multi-carousel-list .react-multiple-carousel__arrow--right::before {
  font-size: 16px !important;
  font-weight: 600;
}
.middle-content .alerts-container .react-multi-carousel-list .react-multiple-carousel__arrow--right::after {
  content: "\\e824";
  font-size: 16px;
  color: rgba(255, 255, 255, 0.2);
  font-family: "revicons";
  text-align: center;
  z-index: 1;
  position: absolute;
  top: 0;
  left: -26px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/AlertSection/styles.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AAEQ;EACI,aAAA;EACA,kBAAA;AAAZ;AAEY;EACI,aAAA;EACA,0BAAA;AAAhB;AAGY;EACI,6BAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;AADhB;AAKQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;AAHZ;AAKY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAHhB;AAMY;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;AAJhB;AAQQ;EACI,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AANZ;AAOY;EACI,wCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AALhB;AAOY;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AALhB;AASQ;EACI,mBAAA;AAPZ;AAUQ;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AARZ;AASY;EACI,mBAAA;AAPhB;AASY;EACI,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;AAPhB;AAUY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AARhB;AAWoB;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AATxB;AAagB;EACI,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAXpB;AAaoB;EACI,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXxB;AAcoB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAZxB;AAgBgB;EACI,mCAAA;AAdpB;AAgBoB;EACI,cAAA;AAdxB;AAiBoB;EACI,mBAAA;AAfxB;AAmBgB;EACI,mCAAA;AAjBpB;AAmBoB;EACI,cAAA;AAjBxB;AAoBoB;EACI,mBAAA;AAlBxB;AAwBgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAtBpB;AAyBgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAvBpB;AA6BY;EACI,kCAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AA3BhB;AA8BY;EACI,sBAAA;EACA,sBAAA;AA5BhB;AA8BgB;EACI,0BAAA;EACA,gBAAA;AA5BpB;AA+BgB;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AA7BpB;AAkCgB;EACI,0BAAA;EACA,gBAAA;AAhCpB;AAmCgB;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AAjCpB","sourcesContent":[".middle-content {\n    .alerts-container {\n        background: #202437;\n        padding: 20px 0px 20px 20px;\n        margin-top: 16px;\n        border-radius: 10px;\n        position: relative;\n        overflow: hidden;\n\n        .custom-carousel {\n            height: 170px;\n            position: relative;\n\n            .react-multi-carousel-list {\n                height: 170px;\n                overflow: unset !important;\n            }\n\n            .react-multi-carousel-track {\n                position: absolute !important;\n                left: 0;\n                top: 0;\n                height: 170px;\n            }\n        }\n\n        .alert-top-panel {\n            margin-bottom: 22px;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            width: 90%;\n\n            .d-flex {\n                display: flex;\n                align-items: center;\n                gap: 10px;\n            }\n\n            .alert-icon {\n                border-radius: 10px;\n                border: 1px solid #3B435E;\n                padding: 7px;\n                display: flex;\n            }\n        }\n\n        .alert-title {\n            font-family: 'Poppins';\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 91.523%;\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            span {\n                color: #FFFFFFB2;\n                font-weight: 300;\n                display: flex;\n                align-items: center;\n            }\n            .alert-count{\n                width: 20px;\n                display: flex;\n                justify-content: center;\n            }\n        }\n\n        .alert-wrapper.selected{\n            background: #28304C;\n        }\n        \n        .alert-wrapper {\n            width: 86.872%;\n            height: 136px;\n            padding: 17px 16px;\n            border-radius: 10px;\n            background: #2B3045;\n            cursor: pointer;\n            &:hover{\n                background : #28304C;\n            }\n            span {\n                font-family: 'Poppins';\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 22px;\n                color: rgba(255, 255, 255, 0.70);\n                display: block;\n            }\n\n            .alert-top-items {\n                display: flex;\n                justify-content: space-between;\n                margin-bottom: 19px;\n\n                .left {\n                    .carousel-title {\n                        color: #FFF;\n                        font-size: 16px;\n                        font-weight: 700;\n                        line-height: 120%;\n                        width: 232px;\n                        display: block;\n                        margin-bottom: 10px;\n                    }\n                }\n\n                .right {\n                    border-radius: 3px;\n                    background: rgba(255, 66, 89, 0.10);\n                    padding: 0px 6px;\n                    display: flex;\n                    align-items: center;\n                    gap: 3px;\n                    height: 22px;\n\n                    span {\n                        color: #FF4259;\n                        font-family: 'Manrope';\n                        font-size: 12px;\n                        font-weight: 500;\n                        display: block;\n                    }\n\n                    .circle-icon {\n                        width: 4px;\n                        height: 4px;\n                        border-radius: 50%;\n                        background: #FF4259;\n                    }\n                }\n\n                .right.medium {\n                    background: rgba(255, 139, 30, 0.10);\n\n                    span {\n                        color: #FF8B1E;\n                    }\n\n                    .circle-icon {\n                        background: #FF8B1E;\n                    }\n                }\n\n                .right.low {\n                    background: rgba(88, 218, 120, 0.10);\n\n                    span {\n                        color: #58DA78;\n                    }\n\n                    .circle-icon {\n                        background: #58DA78;\n                    }\n                }\n            }\n\n            .alert-bottom-items {\n                .d-flex {\n                    display: flex;\n                    align-items: center;\n                    gap: 8px;\n                    margin-bottom: 6px;\n                }\n\n                .image-wrapper {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n            }\n        }\n\n        .react-multi-carousel-list {\n            .react-multiple-carousel__arrow {\n                background: transparent !important;\n                position: absolute;\n                top: -50px;\n                left: unset !important;\n                right: 23px !important;\n                min-width: 24px;\n                min-height: 24px;\n            }\n\n            .react-multiple-carousel__arrow--left {\n                left: unset !important;\n                right: 49px !important;\n\n                &::before {\n                    font-size: 16px !important;\n                    font-weight: 600;\n                }\n\n                &::after {\n                    content: \"\\e825\";\n                    font-size: 16px;\n                    color: rgba(255, 255, 255, 0.2);\n                    font-family: \"revicons\";\n                    text-align: center;\n                    z-index: 1;\n                    position: absolute;\n                    top: 0;\n                    left: 26px;\n                    width: 100%;\n                    height: 100%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    pointer-events: none;\n                    font-weight: 600;\n                }\n            }\n\n            .react-multiple-carousel__arrow--right {\n                &::before {\n                    font-size: 16px !important;\n                    font-weight: 600;\n                }\n\n                &::after {\n                    content: \"\\e824\";\n                    font-size: 16px;\n                    color: rgba(255, 255, 255, 0.2);\n                    font-family: \"revicons\";\n                    text-align: center;\n                    z-index: 1;\n                    position: absolute;\n                    top: 0;\n                    left: -26px;\n                    width: 100%;\n                    height: 100%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    pointer-events: none;\n                    font-weight: 600;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
